

























import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ILocale } from "@/@types/locale";
import MultilangInput from "./multilang-input.vue";

@Component({
  components: { MultilangInput },
})
class MultilangArrayInput extends Vue {
  @Prop({ type: Array, default: () => [{}] }) value!: ILocale[];
  @Prop({ type: String, default: "" }) locale!: string;
  @Prop({ type: String, default: "" }) label!: string;

  items: ILocale[] = [];

  @Watch("value", { immediate: true, deep: true })
  onValueChange(): void {
    if (JSON.stringify(this.items) !== JSON.stringify(this.value)) {
      this.items = this.value.map((v) => ({ ...v }));
    }
  }

  @Watch("items", { deep: true })
  onItemsChange(): void {
    this.$emit("input", this.items);
  }

  onItemInput(index: number, updated: ILocale): void {
    this.$set(this.items, index, updated);
  }

  add(): void {
    this.items.push({ [this.locale]: "" });
  }

  remove(index: number): void {
    if (this.items.length > 1) {
      this.items.splice(index, 1);
    }
  }
}

export default MultilangArrayInput;
